var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_vm._t("title"),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"text"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],2),_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }